import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { CrudService } from "src/app/services/crud.service";
import { UtilService } from "src/app/services/util.service";
import { Platform } from "@ionic/angular";
import { AuthService } from 'src/app/services/auth.service';
import { UserType } from 'src/models/user.model';
import { Capacitor } from "@capacitor/core";

enum TipoLinkIndicacao {
  RESERVA_RESTAURANTE = "RESERVA_RESTAURANTE",
  CORRIDA = "CORRIDA"
}

@Component({
    selector: "app-generate-link",
    templateUrl: "./generate-link.html",
    styleUrls: ["./generate-link.component.scss"],
    providers: [],
    standalone: false
})
export class GenerateLinkComponent implements OnInit {
  form: UntypedFormGroup;
  isPageShare = false;
  linkShare = "";
  isPwa = false;
  claim: UserType;
  typeIndication = TipoLinkIndicacao;
  constructor(
    private fb: UntypedFormBuilder,
    private crud: CrudService,
    private util: UtilService,
    private platform: Platform,
    private auth: AuthService
  ) {
    this.isPwa = !Capacitor.isNativePlatform();
  }

  ngOnInit() {

    this.form = this.fb.group({
      nomeCliente: ["", Validators.required],
      celular: ["", Validators.minLength(5)],
      TipoLinkIndicacao: ['', Validators.required]
    });
    

  }

  check() {
    
  }

  submitForm(): void | boolean {
    this.crud.postData("Link", null, this.form.value).subscribe(
      (response: any) => {
        this.linkShare = response.data.linkUrl;
        this.isPageShare = true;
      },
      (error) => {
        this.util.showToast("An error occurred to generate the link");
      }
    );
  }

  copyLink() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.linkShare)
        .then(() => this.util.showToast("Link copied"))
        .catch(() => {
          this.copyToClipboard(this.linkShare);
          this.util.showToast("Link copied");
        });
    } else {
      this.copyToClipboard(this.linkShare);
      this.util.showToast("Link copied");
    }
  }

  async shareLink() {
    const message = `Hello. This is the link to use GoSpread.`;

    if (navigator.share) {
      await navigator.share({
        title: "GoSpread - Guest Link",
        text: message,
        url: this.linkShare,
      }).catch(console.error);
    } else {
      window.open(`https://wa.me/?text=${message} ${this.linkShare}`, "_blank");
    }
  }

  copyToClipboard(string) {
    let textarea;
    let result;

    try {
      textarea = document.createElement("textarea");
      textarea.setAttribute("readonly", true);
      textarea.setAttribute("contenteditable", true);
      textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
      textarea.value = string;

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      const range = document.createRange();
      range.selectNodeContents(textarea);

      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      textarea.setSelectionRange(0, textarea.value.length);
      result = document.execCommand("copy");
    } catch (err) {
      console.error(err);
      result = null;
    } finally {
      document.body.removeChild(textarea);
    }

    // manual copy fallback using prompt
    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
      const copyHotkey = isMac ? "⌘C" : "CTRL+C";
      result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
      if (!result) {
        return false;
      }
    }
    return true;
  }
}
